import { createContext, ReactNode } from 'react';

interface DynamicUIContextType {
    open: (render: (onClose: () => void) => ReactNode) => void;
}

const DynamicUIContext = createContext<DynamicUIContextType>({
    open: () => {
        throw new Error('DynamicUIContext not implemented');
    },
});

export default DynamicUIContext;
